export default {
  title: 'Import Material Composition',
  helpText: 'Paste the text of a material composition into the field below – for example, copied from a datasheet or a website. The tool automatically detects the ranges of the contained alloying elements and displays them directly in the preview table.',
  failure: {
    summary: 'Incomplete or ambiguous values detected',
    details: 'Some alloying elements were recognized, but the corresponding values are missing or could not be clearly interpreted. Please review the list below and complete the missing information manually.',
    emptyValue: 'No values were found for the alloying element',
    addToComposition: 'Add element',
    removeFromComposition: 'Remove element',
  },
};
